import { DOC_TYPE } from "../enums";

export interface CreateDocuments {
  folderName: string;
  pId?: string;
  project_id?: string;
}

export interface RenameFileFolder {
  editFileFolderName: string;
  editFileFolderId: string;
  pId?:string;
  type?: string;
}

export interface DocumentsList {
  bookmarked: string;
  createdOn: Date | string;
  id: string;
  isOwner: string;
  name: string;
  parentId: string;
  project_id: string;
  project_name: string;
  type: DOC_TYPE;
  user_firstname: string;
  user_lastname: string;
  user_fullname: string;
  user_id: string;
  usr_name: string; //incase of shared to me list
  usr_lastname: string; //incase of shared to me list
  folderpath: string;
}

export interface UploadFile {
  file: string;
  pId?: string;
}

export interface DocumentDetail {
  Histroy: DocumentHistory[];
  data: DocumentData[];
  message: string;
  status: boolean;
}

export interface DocumentHistory {
  action: string;
  canEdit: string;
  date: string;
  fromName: string;
  itemType: string;
  targetProfileImage: string;
  targetUserName: string;
  toName: string;
  type: string;
  userInd: string;
}

export interface DocumentData {
  createdOn: Date | string;
  description: string;
  location: string;
  name: string;
  ownerName: string;
  parentId: string;
  sharedWith: {
    canEdit: string;
    image: string;
    name: string;
  }[];
  type: string;
}

export interface ShareFileFolder {
  folderId: string;
  notifyPeople: boolean;
  shareto: Date | string;
  tagsList: TagDetails[];
}

export interface TagDetails {
  type: string;
  name: string;
  tagName: string;
}
